import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import _ from 'lodash';
import Api from '../../../../../api/api';
import classes from './tabs.module.scss';
import Utils from '../../../../../utils/utils';
import Button from '../../../../_common/Form/Buttons/Button';
import InputField from '../../../../_common/Form/TextFields/InputField';

const productTypes = ['Biosimilars', 'Brand', 'Generic', 'Immunotherapy'];

const ProductType = () => {
  const health = useSelector((store) => store.healths.healthList[0]);

  const [data, setData] = useState({});
  const [saveLoading, saveLoadingToggle] = useState(false);

  useEffect(() => {
    if (health) {
      setData(Object.fromEntries(productTypes.map((p) => [p, health[p] ?? ''])));
    }
  }, [health]);

  const changeValue = (path, value) => {
    setData((prev) => ({ ...prev, [path]: value }));
  };

  const save = async () => {
    saveLoadingToggle(true);

    try {
      const sendingData = {};

      _.forEach(data, (value, key) => {
        sendingData[key] = value || 0;
      });

      await Api.updateHealth({ ...sendingData, id: health.id });

      toast.success('Successfully saved');
    } catch (e) {
      toast.error('Something went wrong');
    }

    saveLoadingToggle(false);
  };

  return (
    <div className={classes.product_type_wrapper}>
      {productTypes.map((p) => (
        <div key={p} className={classes.product_type_row}>
          <p>{p}</p>

          <InputField
            placeholder="0"
            value={data[p]}
            onChange={(value) => changeValue(p, value)}
            onKeyPress={(e) => Utils.keyPressCurrency(e, false, 100, 2)}
            onPaste={(e) => Utils.keyPressCurrency(e, true, 100, 2)}
          />
        </div>
      ))}

      <Button
        title="Save"
        className={classes.save_btn}
        type="button"
        reverseColor
        loading={saveLoading}
        onClick={save}
      />
    </div>
  );
};

export default ProductType;
